import moment from 'moment-timezone';

import { DATE_SHORTCUTS } from './constants';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import { ESystemType } from '@src/emp-3.0/types';

function calcShortcutInterval(shortcut) {
  switch (shortcut) {
    case DATE_SHORTCUTS.last6Hours:
      return [moment().subtract(6, 'hours').startOf('minute'), moment()];
    case DATE_SHORTCUTS.past24Hours:
      return [moment().subtract(24, 'hours').startOf('minute'), moment().startOf('minute')];
    case DATE_SHORTCUTS.today:
      return [moment().startOf('day'), moment()];
    case DATE_SHORTCUTS.yesterday:
      return [
        moment().subtract(1, 'days').startOf('day'),
        moment().subtract(1, 'days').endOf('day'),
      ];
    case DATE_SHORTCUTS.lastWeek:
      return [
        moment().subtract(1, 'week').startOf('week'),
        moment().subtract(1, 'week').endOf('week'),
      ];
    case DATE_SHORTCUTS.thisMonth:
      return [moment().startOf('month'), moment().startOf('day')];
    case DATE_SHORTCUTS.lastMonth:
      return [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ];
    case DATE_SHORTCUTS.last7Days:
      return [moment().subtract(6, 'days').startOf('day'), moment().endOf('day')];
    case DATE_SHORTCUTS.past7Days:
      return [
        moment().subtract(7, 'days').startOf('day'),
        moment().subtract(1, 'day').endOf('day'),
      ];
    case DATE_SHORTCUTS.past14Days:
      return [
        moment().subtract(14, 'days').startOf('day'),
        moment().subtract(1, 'day').endOf('day'),
      ];
    case DATE_SHORTCUTS.past30Days:
      return [
        moment().subtract(30, 'days').startOf('day'),
        moment().subtract(1, 'day').endOf('day'),
      ];
    case DATE_SHORTCUTS.past90Days:
      return [
        moment().subtract(90, 'days').startOf('day'),
        moment().subtract(1, 'day').endOf('day'),
      ];
    case DATE_SHORTCUTS.past1Year:
      return [
        moment().subtract(1, 'year').startOf('day'),
        moment().subtract(1, 'day').endOf('day'),
      ];
    default:
      return [];
  }
}

export function calcShortcutIntervalWithinBoundary(shortcut, src) {
  const calendarBoundry =
    src === ESystemType.Trends
      ? useInitialInfoStore.getState().trendsCalenderBoundry
      : useInitialInfoStore.getState().empCalenderBoundry;
  const boundStart = moment(calendarBoundry.start_time);
  const boundEnd = moment(calendarBoundry.end_time);

  let rawStart;
  let rawEnd = boundEnd;

  switch (shortcut) {
    case DATE_SHORTCUTS.last6Hours:
      rawStart = moment(boundEnd).subtract(6, 'hours').startOf('minute');
      break;
    case DATE_SHORTCUTS.past24Hours:
      rawStart = moment(boundEnd).subtract(24, 'hours').startOf('minute');
      rawEnd = moment(boundEnd).startOf('minute');
      break;
    case DATE_SHORTCUTS.today:
      rawStart = moment(boundEnd).startOf('day');
      break;
    case DATE_SHORTCUTS.yesterday:
      rawStart = moment(boundEnd).subtract(1, 'days').startOf('day');
      rawEnd = moment(boundEnd).subtract(1, 'days').endOf('day');
      break;
    case DATE_SHORTCUTS.lastWeek:
      rawStart = moment(boundEnd).subtract(1, 'week').startOf('week');
      rawEnd = moment(boundEnd).subtract(1, 'week').endOf('week');
      break;
    case DATE_SHORTCUTS.thisMonth:
      rawStart = moment(boundEnd).startOf('month');
      rawEnd = moment(boundEnd).startOf('day');
      break;
    case DATE_SHORTCUTS.lastMonth:
      rawStart = moment(boundEnd).subtract(1, 'month').startOf('month');
      rawEnd = moment(boundEnd).subtract(1, 'month').endOf('month');
      break;
    case DATE_SHORTCUTS.last7Days:
      rawStart = moment(boundEnd).subtract(6, 'days').startOf('day');
      rawEnd = moment(boundEnd).endOf('day');
      break;
    case DATE_SHORTCUTS.past7Days:
      rawStart = moment(boundEnd).subtract(7, 'days').startOf('day');
      rawEnd = moment(boundEnd).subtract(1, 'day').endOf('day');
      break;
    case DATE_SHORTCUTS.past14Days:
      rawStart = moment(boundEnd).subtract(14, 'days').startOf('day');
      rawEnd = moment(boundEnd).subtract(1, 'day').endOf('day');
      break;
    case DATE_SHORTCUTS.past30Days:
      rawStart = moment(boundEnd).subtract(30, 'days').startOf('day');
      rawEnd = moment(boundEnd).subtract(1, 'day').endOf('day');
      break;
    case DATE_SHORTCUTS.past90Days:
      rawStart = moment(boundEnd).subtract(90, 'days').startOf('day');
      rawEnd = moment(boundEnd).subtract(1, 'day').endOf('day');
      break;
    case DATE_SHORTCUTS.past1Year:
      rawStart = moment(boundEnd).subtract(1, 'year').startOf('day');
      rawEnd = moment(boundEnd).subtract(1, 'day').endOf('day');
      break;
    default:
      return [];
  }

  // Clip to calendar boundaries
  const clippedStart = moment.max(rawStart, boundStart);
  const clippedEnd = moment.min(rawEnd, boundEnd);

  return clippedStart.isAfter(clippedEnd) ? [] : [clippedStart, clippedEnd];
}

export default calcShortcutInterval;
